module.exports = __webpack_public_path__ + "static/mainframe-logo-86cc3c7ac9e34c17ba8c30f73e62e906.jpeg";